import { autoinject, bindable, inject } from "aurelia-framework";
import { ServiceDataItemHandler } from "../services/measure-service";
import { AttachedDataItem, ReportedServiceDataItemType } from "../../reported-service-data-items/reported-service-data-item-models";
import { DataItemOption, ReportedServiceDataItemService } from "../../customers/reported-service-data-item-service";
import { ReportedDataItemsForm } from "../reported-data-items-form";
import { ScopeType } from "../../scopes/scope-type-service";
import { ResourceService } from '../../../utils/resourceService';

@autoinject
export class MeasureAttachedRow {

	@bindable attachedDataItem: AttachedDataItem;
	@bindable availableDataItems: DataItemOption[];
	@bindable availableScopeTypes: ScopeType[];
	@bindable customerId: string;
	@bindable allowTags: boolean;
	@bindable allowCustomerComparisonSelection: boolean;
	@bindable getUsedScopetypesForMeasure: (measureId: any) => string[];

	private showEditForm = false;
	private isDescriptionChangeable: boolean;

	constructor(
		private measureHandler: ServiceDataItemHandler,
		private droppableHandler: ReportedDataItemsForm,
		private resources: ResourceService
	) {}

	attached() {
		/**
		 * This component is used in both default-measure-edit and reported-service-data-item-edit views.
		 * Only the customer specific reported-service-data-item component should be able to edit measure description.
		 *
		 * By implementing changeDescription function the measureHandler dictates whether the description is changeable.
		 */
		this.isDescriptionChangeable =
			typeof this.measureHandler.changeDescription === "function";
	}

	async stateChanged(state: boolean, inputType: string) {
		var result = await this.measureHandler.setInputTypeState(
			this.attachedDataItem,
			inputType,
			state
		);

		if (result instanceof Error && result.message === ReportedServiceDataItemService.error_CannotRemoveLastInputFromCustomerComparisonMeasure) {
			alert(this.resources.getResource("MeasureAttachForm_ErrorMessage_CustomerComparisonMeasureMustHaveAtLeastOneCollectionSelection"));
			this.attachedDataItem[inputType] = true;
		}
	}

	confirmCustomerComparisonStateChange(event: Event, selected: boolean, item: AttachedDataItem) {

		if (item.type === ReportedServiceDataItemType.Measure && !item.forCostCentersTotal && !item.forCostCentersByMunicipalities && !item.forServiceTotal && !item.forServiceByMunicipalities) {
			alert(this.resources.getResource("MeasureAttachForm_ErrorMessage_CustomerComparisonMeasureMustHaveAtLeastOneCollectionSelection"));
			return false;
		}

		const confirmMessage = selected ?
			this.resources.getResource('MeasureAttachForm_Confirm_AddRowToCustomerComparison', [ item.displayName ]) : this.resources.getResource('MeasureAttachForm_Confirm_RemoveRowFromCustomerComparison', [item.displayName]);

		return confirm(confirmMessage);
	}

	customerComparisonStateChanged(state: boolean, item: AttachedDataItem) {
		this.measureHandler.changeCustomerComparisonState(item);
	}

	detach() {
		this.measureHandler.detachDataItem(this.attachedDataItem);
		this.showEditForm = false;
	}

	toggleDescription() {
		if (this.showEditForm) {
			this.showEditForm = false;
		} else {
			if (
				!this.attachedDataItem.description ||
				!this.attachedDataItem.description.length
			) {
				let option = this.availableDataItems.filter(
					i => i.id == this.attachedDataItem.dataItemId
				)[0];
				this.attachedDataItem.description = option
					? option.description
					: "";
			}
			this.showEditForm = true;
		}
	}

	changeDescription() {
		this.measureHandler.changeDescription(this.attachedDataItem);
		this.toggleDescription();
	}
	
	toggleButtonLabel(firstHeaderResource: string, secondHeaderResource: string) : string {
		const firstHeader = this.resources.getResource(firstHeaderResource);
		const secondHeader = this.resources.getResource(secondHeaderResource);
		return `${firstHeader} ${secondHeader}`;
	}
}
